import React from "react";
import PropTypes from "prop-types";
import { Nav } from "reactstrap";

const SideNav = ({ children }) => (
  <Nav className="side-nav" vertical>
    {children}
  </Nav>
);

SideNav.propTypes = {
  children: PropTypes.node.isRequired
};

export default SideNav;
